import {FeeScheduleItemDataModel} from './fee-schedule-item-data.model';

export class FeeScheduleItemFeeDataModel {
  DocFeeScheduleItemID: string;
  FeeScheduleItemID: string;
  DocFeeScheduleID: string;
  Fee: number;

  dataFeeScheduleItem: FeeScheduleItemDataModel;
}
